var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7071 10.293C19.0976 10.6835 19.0976 11.3167 18.7071 11.7072C18.3166 12.0978 17.6834 12.0978 17.2929 11.7072L13 7.41434L13 19.0001C13 19.5524 12.5523 20.0001 12 20.0001C11.4477 20.0001 11 19.5524 11 19.0001L11 7.41434L6.70711 11.7072C6.31658 12.0978 5.68342 12.0978 5.29289 11.7072C4.90237 11.3167 4.90237 10.6835 5.29289 10.293L11.2929 4.29302C11.6834 3.90249 12.3166 3.90249 12.7071 4.29302L18.7071 10.293Z",
    fill: "black"
  })));
};
export { SvgArrowUp as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up.2cb82f9f.svg";